export enum PassengersPageId {
	Home = 'mco-home',
	Flights = 'flights',
	ShopDineRelax = 'shop-and-dine',
	SecurityWaitTimes = 'security-wait-times',
	FlightDetailArrival = 'arrival',
	FlightDetailDeparture = 'departure',
	NotFound = 'not-found',
	ParkingAvailability = 'parking-availability',
	Map = 'map',
	Privacy = 'privacy-policy',
	Airlines = 'page-airlines',
	RentalCars = 'rental-cars',
	Media = 'media',
	MediaPressReleases = 'media-press-releases',
	MediaIndustryNews = 'media-industry-news',
	MediaCenter = 'media-center',
}

export enum BusinessPageId {
	Home = 'business-home',
	News = 'news',
	SunshineMeetings = 'sunshine-meetings-documents',
	SunshineMeetingsCalendars = 'sunshine-meetings-calendars',
	Contracts = 'contracts',
	Policies = 'policies',
}

export enum CareersPageId {
	Home = 'careers-home',
	Jobs = 'jobs',
}

export enum GeneralPageId {
	Search = 'search',
}

export enum ORLPageId {
	Home = 'orl-home',
}

export enum MCOCaresPageId {
	Home = 'mco-cares-home',
}

export const OTHER_WEBSITES_ID = 'other-websites';
